import React from "react";
import "./Customer_Feedback_On_Return.css";
import { Form, Modal } from "react-bootstrap";

function Customer_Feedback_On_Return({ ...props }) {
  console.log(props, "props");

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_Details_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Customer Feedback
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="View_Details">
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Feedback Reason :-</Form.Label>
              </div>

              <div className="col-md-6">
                <b>{props?.feedback?.reason || "-"}</b>
              </div>
            </div>
            <br></br>

            <div className="row">
              <div className="col-md-6">
                <Form.Label>Feedback Remark :-</Form.Label>
              </div>

              <div className="col-md-6">
                <b>{props?.feedback?.remark || "-"}</b>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Customer_Feedback_On_Return;
